require('./jquery-accessibleMegaMenu');

export default function navigation() {
    // init accessible mega menu
    if (jQuery) {
        (function( $ ) {
            "use strict";
            $( document ).ready( function() {
                // initialize the megamenu
                $( '.megamenu' ).accessibleMegaMenu( {
                    uuidPrefix: "accessible-megamenu",
                    menuClass: "accessible-megamenu",
                    topNavItemClass: "accessible-megamenu-top-nav-item",
                    panelClass: "accessible-megamenu-panel",
                    panelGroupClass: "accessible-megamenu-panel-group",
                    hoverClass: "hover",
                    focusClass: "focus",
                    openClass: "open"
                });

                // hack so that the megamenu doesn't show flash of css animation after the page loads.
                setTimeout( function() {
                    $( 'body' ).removeClass( 'init' );
                }, 500 );
            } );
        }( jQuery ));
    }

    // mobile menu trigger
    var mobileNavTrigger = document.getElementById( 'menu-opener' );
    mobileNavTrigger.addEventListener( 'click', function() {

        var searchButton = document.getElementById('openSearch');
        searchButton.classList.remove( 'isOpen' );
        searchButton.setAttribute('aria-expanded', "false" );
        var nextElem = searchButton.nextElementSibling;
        nextElem.setAttribute('aria-hidden', "true" );

        // mark trigger als active
        this.classList.toggle( 'isOpen' );
        this.setAttribute('aria-expanded', ( this.attributes['aria-expanded'].value == "true" ) ? "false" : "true" );

        // open mobile menu
        var targetId = this.attributes['aria-controls'].value;
        var target = document.getElementById( targetId );
        target.setAttribute('aria-hidden', ( target.attributes['aria-hidden'].value == "true" ) ? "false" : "true" );
    } );

    // show main level link in dropdown on desktop
    ToggleMainLevelLinksVisibility();
    window.addEventListener("resize", function(){
        ToggleMainLevelLinksVisibility();
    });
};

function ToggleMainLevelLinksVisibility() {
    var mainLevelLinks =  document.getElementsByClassName( 'main-level-link' );
    if(window.innerWidth >= 768){
        Array.prototype.forEach.call(mainLevelLinks, function ( link ) {
            link.hidden = false;
        });

    } else {
        Array.prototype.forEach.call(mainLevelLinks, function ( link ) {
            link.hidden = true;
        });
    }
}
